import React from "react";
import { connect } from "react-redux";
import { Button } from "devextreme-react";
import { setStepWizard, setOpening } from "../actions";
import TagField from "../../../../../Shared/fields/TagField";

class formIngresoApertura extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showError: false,
    };
  }
  handleBack = () => {
    this.props.dispatch(setStepWizard({
      stepOne: true,
      stepTwo: false,
      stepThree: false,
      stepSuccess: false,
    }));
  }

  handleSelectionExmanPool = (e) => {
    const NewOpening = { ...this.props.Opening };
    NewOpening.ExamPools = e.value;
    if (NewOpening.IdConfig > 0) {
      NewOpening.isNewConfig = true;
    }
    this.props.dispatch(setOpening(NewOpening));
  }
  handleSelectionExmans = (e) => {
    const NewOpening = { ...this.props.Opening };
    NewOpening.Exams = e.value;
    if (NewOpening.IdConfig > 0) {
      NewOpening.isNewConfig = true;
    }
    this.props.dispatch(setOpening(NewOpening));
  }
  handleSelectionCiel = (e) => {
    const NewOpening = { ...this.props.Opening };
    NewOpening.Ciel = e.value;
    if (NewOpening.IdConfig > 0) {
      NewOpening.isNewConfig = true;
    }
    this.props.dispatch(setOpening(NewOpening));
  }



  handleNext = (e) => {
    const Opening = { ...this.props.Opening };

    let isValid = false;
    if (Opening.ExamPools.length > 0 || Opening.Exams.length > 0 || Opening.Ciel.length > 0)
      isValid = true;

    this.setState({ showError: !isValid });

    if (isValid) {
      this.props.dispatch(setStepWizard({
        stepOne: false,
        stepTwo: false,
        stepThree: true,
        stepSuccess: false,
      }));
    }
  }
  render() {
    const {
      Opening,
      centerConfig,
    } = this.props;
    return (
      <React.Fragment>
        {Opening.IdCentro !== null && (
          <React.Fragment>
            <div className="col-12 text-center" style={{ marginTop: 15 }}>
              Seleccione las baterías que estarán disponibles en la apertura
              </div>
            <div className="col-12">
              <TagField
                id="tagBaterias"
                label="Baterías"
                dataSource={centerConfig.listExamPools}
                className="tag-box-roles"
                displayExpr="Name"
                valueExpr="id"
                onValueChanged={this.handleSelectionExmanPool}
                showSelectionControls
                maxDisplayedTags={2}
                showMultiTagOnly={false}
                defaultValue={Opening.ExamPools}
                searchEnabled
                validation={false}
              />
            </div>
            <div className="col-12">
              <TagField
                id="tagPrestaciones"
                dataSource={centerConfig.listExams}
                className="tag-box-roles"
                displayExpr="Name"
                label="Prestaciones SEP"
                valueExpr="id"
                onValueChanged={this.handleSelectionExmans}
                showSelectionControls
                maxDisplayedTags={2}
                showMultiTagOnly={false}
                defaultValue={Opening.Exams}
                validation={false}
                searchEnabled
              />
            </div>
            <div className="col-12">
              <TagField
                id="tagBaterias"
                label="Prestaciones CIEL"
                dataSource={centerConfig.listCiel}
                className="tag-box-roles"
                displayExpr="Name"
                valueExpr="id"
                onValueChanged={this.handleSelectionCiel}
                showSelectionControls
                maxDisplayedTags={2}
                showMultiTagOnly={false}
                defaultValue={Opening.Ciel}
                validation={false}
                searchEnabled
              />
            </div>

            {this.state.showError &&
              <div className="col-12 text-center red-text" style={{ marginTop: 30 }}>
                Debe seleccionar mínimo una Bateria, Prestacion adicional o Ciel
                </div>
            }

            <div className="button-row">
              <div>
                <Button
                  onClick={this.handleBack}
                  text="volver"
                />
              </div>
              <div>
                <Button
                  onClick={this.handleNext}
                  type="success"
                  text="Siguiente"
                />
              </div>
            </div>
          </React.Fragment>
        )}

      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  Opening: state.aperturasSel.Opening,
  centerConfig: state.aperturasSel.centerConfig,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(formIngresoApertura);
